// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--3iF8I","link":"styles-module--link--bgZRb","icon":"styles-module--icon--wTMWn"};